const prefix = "LEVY_COLLECTION_";

export const CREATE = prefix + "CREATE";
export const EDIT_DATA_SOURCE_CONFIGURATION_GET = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_GET";
export const EDIT_DATA_SOURCE_CONFIGURATION_SAVE = prefix + "EDIT_DATA_SOURCE_CONFIGURATION_SAVE";
export const EDIT_EMAIL_CONFIGURATION_GET = prefix + "EDIT_EMAIL_CONFIGURATION_GET";
export const EDIT_EMAIL_CONFIGURATION_SAVE = prefix + "EDIT_EMAIL_CONFIGURATION_SAVE";
export const EDIT_FEES_GET = prefix + "EDIT_FEES_GET";
export const EDIT_FEES_SAVE = prefix + "EDIT_FEES_SAVE";
export const EDIT_INFORMATION_SESSION_DELETE = prefix + "EDIT_INFORMATION_SESSION_DELETE";
export const EDIT_INFORMATION_SESSION_GET = prefix + "EDIT_INFORMATION_SESSION_GET";
export const EDIT_INFORMATION_SESSION_SAVE = prefix + "EDIT_INFORMATION_SESSION_SAVE";
export const EDIT_INVOICE_CONFIGURATION_GET = prefix + "EDIT_INVOICE_CONFIGURATION_GET";
export const EDIT_INVOICE_CONFIGURATION_SAVE = prefix + "EDIT_INVOICE_CONFIGURATION_SAVE";
export const EDIT_INVOICING_TIMING_CONFIGURATION_GET = prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_GET";
export const EDIT_INVOICING_TIMING_CONFIGURATION_SAVE = prefix + "EDIT_INVOICING_TIMING_CONFIGURATION_SAVE";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET = prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_GET";
export const EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE = prefix + "EDIT_NON_COMPLIANCE_HISTORY_CONFIGURATION_SAVE";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET = prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_GET";
export const EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE =
  prefix + "EDIT_LEVY_CALCULATION_TIMING_CONFIGURATION_SAVE";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET = prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_GET";
export const EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE = prefix + "EDIT_PUBLIC_LEVY_ESTIMATOR_CONFIGURATION_SAVE";
export const FINISH_SETUP = prefix + "FINISH_SETUP";
export const GET_COMPONENT_LEVY_AMOUNTS = prefix + "GET_COMPONENT_LEVY_AMOUNTS";
export const GET_PROVIDER_TASKS = prefix + "GET_PROVIDER_TASKS";
export const GET_STATUS_HISTORY = prefix + "GET_STATUS_HISTORY";
export const INVOICE_TEMPLATE_UPLOAD = prefix + "INVOICE_TEMPLATE_UPLOAD";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const RUN_PROVIDER_TASK = prefix + "RUN_PROVIDER_TASK";
export const TASK_RUN = prefix + "TASK_RUN";
export const TASKS_GET = prefix + "TASKS_GET";
export const VIEW = prefix + "VIEW";
export const VIEW_EMAIL_CONFIGURATION = prefix + "VIEW_EMAIL_CONFIGURATION";
export const VIEW_FEES = prefix + "VIEW_FEES";
export const VIEW_DATA_SOURCE_CONFIGURATION = prefix + "VIEW_DATA_SOURCE_CONFIGURATION";
export const VIEW_INFORMATION_SESSIONS = prefix + "VIEW_INFORMATION_SESSIONS";
export const VIEW_INVOICE_CONFIGURATION = prefix + "VIEW_INVOICE_CONFIGURATION";
export const VIEW_INVOICING_TIMING_CONFIGURATION = prefix + "VIEW_INVOICING_TIMING_CONFIGURATION";
export const VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION = prefix + "VIEW_NON_COMPLIANCE_HISTORY_CONFIGURATION";
export const VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION = prefix + "VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
